"use client"

import { ComponentConfig } from "@measured/puck"
import { message } from "antd"
import { useEffect, useState } from "react"
import { fetchRecruitments } from "../../../../../recruitment/services/recruitment"
import { configs, DefaultImage } from "../../../../external-components"
import { RecruitmentData } from "../../../types"

export type CompaniesSectionProps = {
  items: {
    id?: number
    image?: string
    text?: string
    url?: string
    company?: string
  }[]
}

export const RenderConfig: ComponentConfig<CompaniesSectionProps> = {
  render: ({ items }: { items: CompaniesSectionProps["items"] }) => {
    const [recruitments, setRecruitments] = useState<RecruitmentData[]>([])

    const fetchDataRecruitment = async () => {
      try {
        const response = await fetchRecruitments()

        if (response && response.data) {
          setRecruitments(response.data)
        } else {
          setRecruitments([])
        }
      } catch (error) {
        message.error("Failed to fetch recruitment data")
      }
    }

    const countQuantity = (nameCompany: string) => {
      let total = 0
      if (recruitments && Array.isArray(recruitments)) {
        const filteredRecruitments = recruitments.filter(
          recruitment => recruitment?.attributes?.company?.toLowerCase() === nameCompany.toLowerCase(),
        )
        filteredRecruitments.forEach(recruitment => {
          total += recruitment?.attributes?.Quantity || 0
        })

        return total
      }
    }

    useEffect(() => {
      fetchDataRecruitment()
    }, [])

    return (
      <div className="w-[1140px] max-sm:w-full pr-[15px] flex justify-center">
        <div className="inline-flex max-sm:grid max-sm:grid-cols-2 max-sm:pl-[15px] max-sm:gap-[30px]">
          {items.map((item, index) => (
            <div
              key={index}
              className="relative w-[285px] h-[183px] flex flex-col justify-center items-center max-sm:w-full max-sm:h-full max-sm:py-[28px] max-sm:px-[27px]"
            >
              <a href={item.url}>
                <div>
                  <img
                    className="w-[201px] hover:scale-110 max-sm:w-full transition-all duration-300"
                    src={item.image ? `${configs.API_URL}${item.image}` : DefaultImage}
                    alt={`imageCustomer ${index}`}
                  />
                </div>
              </a>
              <div className="mt-[12px] font-semibold text-[14px]">
                <p className="text-center">
                  {(item.company ? countQuantity(item.company) : 0) + ` ${item.text ?? "Vị trí tuyển dụng"}`}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  },
}
